const ORQUESTADOR = {
  MS_HOST:   'https://apilocal.bci.cl/bci-produccion/api-bci',
  MS_BRANCH: 'v2.0',
  MS_URL:    '/ventas-y-servicios/gestion-clientes/ms-creacionclavecliente-orq'
};
export const environment = {
  demo: false,
  production: true,
  hmr: false,
  ibm_client_id: '0dab04f4-9790-4606-8511-66dc5400aa9d',
  timeout: 30000,
  ENDPOINT_MS: '',
  PATH: 'creacion-clave/',
  siteKeyCaptcha: '6LdIphoUAAAAAMbp5x9bour0pmH5PNR92wJJ5MDP',
  siteHome: 'https://www.bci.cl/personas',
  creacionClave: {
    URL_ORQUESTADOR: `${
        ORQUESTADOR.MS_HOST +
        ORQUESTADOR.MS_URL + "/" +
        ORQUESTADOR.MS_BRANCH
      }`,
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts